import { classNames, cn } from '@/utils';
import cls from 'classnames';
import type { FC, ReactElement } from 'react';
import { cloneElement, memo } from 'react';
import { useNodeDefault } from '../../hooks/use-node-default';
import NodeIcon from '../../node-icon';
import { NodeEnum, type NodeProps } from '../../types';
import MoreBtn from './more-btn';
import { NodeSourceHandle, NodeTargetHandle } from './node-handle';

type NodeWrapperProps = {
  children: ReactElement;
} & NodeProps;

const NodeWrapper: FC<NodeWrapperProps> = ({ id, data, children }) => {
  // const nodeRef = useRef<HTMLDivElement>(null);

  const showSelectedBorder =
    data._selected || data._isBundled || data._isEntering;

  const { deletable = true } = useNodeDefault(data.type);

  const hideErrorStatus = data.type === NodeEnum.Start;
  const isValid = data.valid;

  return (
    <div
      className={cn(
        'group relative',
        'w-[220px] min-h-[46px] py-2 px-4',
        'border-2 border-transparent',
        'shadow-[0px_4px_12px_0px_rgba(178,192,217,0.3)] rounded-lg bg-white',
        showSelectedBorder ? 'border-[#4E71F7]' : 'border-transparent',
        'group',
      )}
    >
      {deletable && (
        <div className="absolute top-3 right-5 hidden group-hover:block">
          <MoreBtn nodeId={id} />
        </div>
      )}
      {!data._isCandidate && (
        <NodeTargetHandle
          id={id}
          data={data}
          handleClassName="!top-[12px] !-left-[9px] !translate-y-0 "
          handleId="target"
        />
      )}
      <div className="grow h-full w-full flex items-center gap-1 ">
        <NodeIcon type={data.type} className="size-6 shrink-0" />
        <div className="relative max-w-[80%] min-w-0">
          <div
            className={classNames(
              cls(
                hideErrorStatus && '!hidden',
                isValid && '!hidden',
                'absolute -right-1 -top-[0.5px] size-2 bg-[#FD5844] rounded-full',
              ),
            )}
          />
          <div className=" font-medium truncate">{data?.title}</div>
        </div>
      </div>
      {cloneElement(children, { id, data })}
      <NodeSourceHandle
        id={id}
        data={data}
        handleClassName="!top-[12px] !-right-[9px] !translate-y-0 "
        handleId="source"
      />
    </div>
  );
};

export default memo(NodeWrapper);
